import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useCallback } from 'react';

import ConfirmationDialog from '~components/Dialog/ConfirmationDialog';

interface AssignTypeMismatchDialogProps {
  equipmentTypeName: string;
  isOpen: boolean;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  requestedEquipmentTypeName: string;
  vendorName: string;
}

export default function AssignTypeMismatchDialog({
  equipmentTypeName,
  isOpen,
  isSubmitting = false,
  onCancel,
  onConfirm,
  requestedEquipmentTypeName,
  vendorName,
}: AssignTypeMismatchDialogProps) {
  const handleClose = useCallback(() => {
    if (isSubmitting) {
      return;
    }

    onCancel();
  }, [isSubmitting, onCancel]);

  return (
    <ConfirmationDialog
      confirmButtonProps={{
        children: t('dispatch.drivers.assign_truck_type_mismatch_confirm'),
        color: 'primary',
      }}
      isBusy={isSubmitting}
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={onConfirm}
      title={t('dispatch.drivers.assign_truck_type_mismatch_title')}
    >
      <Typography variant="body2">
        {t('dispatch.drivers.assign_truck_type_mismatch_body', {
          equipmentTypeName,
          requestedEquipmentTypeName,
          vendorName,
        })}
      </Typography>
    </ConfirmationDialog>
  );
}
